import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { decryption } from '../../common/enc_dec';
import { blogList } from '../../api/apiHandler';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import '../../i18';

const BlogDetails = () => {
    const { t } = useTranslation();

    const params = useParams();
    const { blog_id } = decryption(params.id);
    const [blog, setBlog] = useState([]);
    
    useEffect(() => {
        const fetchData = async () => {
            await getBlogDetails();
        };
        
        fetchData();
    },[blog_id])
    
    const getBlogDetails = async () => {
        const response = await blogList({id:blog_id})
        if(response?.code == 200) {
            setBlog(response?.data)
        }
    }

    function formatUTCToCustom(utcDateString) {
        return moment(utcDateString).format('ddd, D MMM [at] HH:mm');
    }

    return (
        <>
            <div className="course-single-area pd-top-120 pd-bottom-90 bgBrown">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="PageTitleBox">
                                <h2 className="PageTitleHeading">{t('blogDetailsHeading')}</h2>
                            </div>
                        </div>
                        <div className="col-xxl-8 col-xl-8 col-lg-9 col-md-12 col-sm-12 col-12">
                            <div className="blog-details-page-content">
                                <div className="single-blog-inner">
                                    <div className="thumb">
                                        <img src={blog?.image} alt="img" />
                                    </div>
                                    <div className="details">
                                        <ul className="blog-meta">
                                            <li>
                                                <i className="fa fa-calendar-check-o" />
                                                {formatUTCToCustom(blog?.blog_date)}
                                            </li>
                                        </ul>
                                        <h6 className="CardMainSubHeading">{blog?.title}</h6>
                                        <p className="CardMainHeading">{blog?.blog_category?.name}</p>
                                        <p className="CardContent description-text">
                                            {blog?.description}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default BlogDetails;